import {
    LIBRARY_DESELECT,
    LIBRARY_FILTER_BUILDING,
    LIBRARY_FILTER_CLIENT,
    LIBRARY_FILTER_PROPERTY,
    LIBRARY_REMOVE_PLAYLIST,
    LIBRARY_REMOVE_QUIZ,
    LIBRARY_REMOVE_VIDEO,
    LIBRARY_SET_DATE_FROM,
    LIBRARY_SET_DATE_UNTIL,
    LIBRARY_SET_ERRORS,
    LIBRARY_SET_PLAYLISTS,
    LIBRARY_SET_PLAYLIST_ENTRY,
    LIBRARY_SET_QUIZZES,
    LIBRARY_SET_QUIZ_ENTRY,
    LIBRARY_SET_SEARCH_STRING,
    LIBRARY_SET_SPECIFICITY,
    LIBRARY_SET_VIDEOS,
    LIBRARY_SET_VIDEO_ENTRY,
    LIBRARY_TOGGLE_FILTERS,
    LIBRARY_TOGGLE_PLAYLIST_MUTATOR,
    LIBRARY_TOGGLE_QUIZ_MUTATOR,
    LIBRARY_TOGGLE_VIDEO_MUTATOR,
    LIBRARY_SET_LOADING,
    LIBRARY_UPDATE_QUIZ,
    LIBRARY_UPDATE_PLAYLIST,
    LIBRARY_UPDATE_VIDEO,
} from '../actionTypes'

import { PLAYLIST, QUIZ, VIDEO } from '../../constants/library'

const defaultState = {
    loading: false,
    errors: [],
    dateFrom: null,
    dateUntil: null,
    filtering: false,
    filteredBuilding: null,
    filteredClient: null,
    filteredProperty: null,
    loadingPlaylists: true,
    loadingQuizzes: true,
    loadingVideos: true,
    mutatingPlaylist: false,
    mutatingQuiz: false,
    mutatingVideo: false,
    playlists: [],
    procedures: [],
    quizzes: [],
    searchString: null,
    selectedEntry: null,
    selectedEntryType: null,
    specificity: 'SUPER',
    showErrors: false,
    videos: [],
}

const libraryReducer = (state = defaultState, action) => {
    switch (action.type) {
        case LIBRARY_SET_LOADING:
            return {
                ...state,
                loading: action.loading,
            }

        case LIBRARY_DESELECT:
            return {
                ...state,
                selectedEntry: null,
                selectedEntryType: null,
            }

        case LIBRARY_FILTER_BUILDING:
            return {
                ...state,
                filteredBuilding: action.building,
            }

        case LIBRARY_FILTER_CLIENT:
            return {
                ...state,
                filteredClient: action.client,
            }

        case LIBRARY_FILTER_PROPERTY:
            return {
                ...state,
                filteredProperty: action.property,
            }

        case LIBRARY_REMOVE_PLAYLIST:
            return {
                ...state,
                playlists: state.playlists.filter((playlist) => playlist.pk !== action.pk),
            }

        case LIBRARY_REMOVE_QUIZ:
            return {
                ...state,
                quizzes: state.quizzes.filter((quiz) => quiz.pk !== action.pk),
            }

        case LIBRARY_REMOVE_VIDEO:
            return {
                ...state,
                videos: state.videos.filter((video) => video.pk !== action.pk),
            }

        case LIBRARY_SET_DATE_FROM:
            return {
                ...state,
                dateFrom: action.timestamp,
            }

        case LIBRARY_SET_DATE_UNTIL:
            return {
                ...state,
                dateUntil: action.timestamp,
            }

        case LIBRARY_SET_ERRORS:
            return {
                ...state,
                errors: [...state.errors, ...action.errors],
                loadingQuizzes: false,
                loadingVideos: false,
                loadingPlaylists: false,
                showErrors: true,
            }

        case LIBRARY_SET_PLAYLISTS:
            return {
                ...state,
                loadingPlaylists: false,
                playlists: action.playlists || [],
                showErrors: false,
            }

        case LIBRARY_SET_PLAYLIST_ENTRY:
            return {
                ...state,
                playlists: [
                    ...state.playlists.filter((playlist) => playlist.pk !== action.playlist.pk),
                    {
                        ...action.playlist,
                        type: PLAYLIST,
                    },
                ],
            }

        case LIBRARY_SET_QUIZZES:
            return {
                ...state,
                loadingQuizzes: false,
                quizzes: action.quizzes || [],
                // showErrors: false
            }

        case LIBRARY_SET_QUIZ_ENTRY:
            return {
                ...state,
                quizzes: [
                    ...state.quizzes.filter((quiz) => quiz.pk !== action.quiz.pk),
                    {
                        ...action.quiz,
                        type: QUIZ,
                    },
                ],
            }

        case LIBRARY_SET_SEARCH_STRING:
            return {
                ...state,
                searchString: action.string,
            }

        case LIBRARY_SET_SPECIFICITY:
            return {
                ...state,
                specificity: action.level,
            }

        case LIBRARY_SET_VIDEOS:
            return {
                ...state,
                loadingVideos: false,
                // showErrors: false,
                videos: action.videos || [],
            }

        case LIBRARY_SET_VIDEO_ENTRY:
            return {
                ...state,
                videos: [
                    ...state.videos.filter((video) => video.pk !== action.video.pk),
                    {
                        ...action.video,
                        type: VIDEO,
                    },
                ],
            }

        case LIBRARY_TOGGLE_FILTERS:
            return {
                ...state,
                filtering: !state.filtering,
            }

        case LIBRARY_TOGGLE_PLAYLIST_MUTATOR:
            return {
                ...state,
                mutatingPlaylist: !state.mutatingPlaylist,
                selectedEntry: action.playlistPk,
                selectedEntryType: 'PLAYLIST',
            }

        case LIBRARY_TOGGLE_QUIZ_MUTATOR:
            return {
                ...state,
                mutatingQuiz: !state.mutatingQuiz,
                selectedEntry: action.quizPk,
                selectedEntryType: 'QUIZ',
            }

        case LIBRARY_TOGGLE_VIDEO_MUTATOR:
            return {
                ...state,
                mutatingVideo: !state.mutatingVideo,
                selectedEntry: action.videoPk,
                selectedEntryType: 'VIDEO',
            }

        case LIBRARY_UPDATE_QUIZ:
            return {
                ...state,
                quizzes: state.quizzes.map((quiz) =>
                    quiz.pk === action.quiz.pk ? action.quiz : quiz
                ),
            }

        case LIBRARY_UPDATE_PLAYLIST:
            return {
                ...state,
                playlists: state.playlists.map((playlist) =>
                    playlist.pk === action.playlist.pk ? action.playlist : playlist
                ),
            }

        case LIBRARY_UPDATE_VIDEO:
            return {
                ...state,
                videos: state.videos.map((video) =>
                    video.pk === action.video.pk ? action.video : video
                ),
            }


        default:
            return state
    }
}

export default libraryReducer
